import { api } from "../../utils/api";


export const NameNewUser = async () => { }
// add name user on

export const ConfirmEmailByToken = async (verificationToken: string) => {
    try {
        const res = await api.get(`/auth-user/verify-email/${verificationToken}`);
        console.log(res.data)
        return res.data;
    } catch (error) {
        console.error("Error confirming email:", error);
        return { verified: false, message: "Error" };
    }
};
